import $ from 'jquery';

//Have this as a global to be used for
//other code that needs to use jQuery
if(!('$' in globalThis)){
    globalThis.$ = $;
}
if(!('jQuery' in globalThis)){
    globalThis.jQuery = $;
}
